import { Resources, useResource } from "Infrastructure/Translation/Resources";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
} from "@mui/material";

type DeleteRegionConfirmationModalProps = {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
	isPending: boolean;
};

const regionResource = Resources.base.market.forms.region;
const formsResource = Resources.base.market.forms;

export const DeleteRegionConfirmationModal = ({
	isOpen,
	onClose,
	onConfirm,
	isPending,
}: DeleteRegionConfirmationModalProps) => {
	const { t } = useResource();

	const handleConfirm = () => {
		onConfirm();
		onClose();
	};

	return (
		<Dialog open={isOpen} onClose={onClose}>
			<DialogTitle>{t(regionResource.deleteConfirmTitle)}</DialogTitle>
			<DialogContent>
				<Typography>{t(regionResource.deleteConfirmMessage)}</Typography>
			</DialogContent>
			<DialogActions>
				<Button variant="outlined" onClick={onClose}>
					{t(formsResource.cancel)}
				</Button>
				<Button
					variant="contained"
					color="error"
					onClick={handleConfirm}
					loading={isPending}
				>
					{t(regionResource.remove)}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
